/* Short two-tone chime via Web Audio — no asset needed. Silently no-ops if autoplay is blocked. */
let ctx = null;

export async function playChime() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = ctx || new AC();
    if (ctx.state === "suspended") await ctx.resume();
    if (ctx.state !== "running") return;
    const t0 = ctx.currentTime;
    [[880, 0], [1174.66, 0.18]].forEach(([freq, offset]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t0 + offset);
      gain.gain.exponentialRampToValueAtTime(0.25, t0 + offset + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + offset + 0.45);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t0 + offset);
      osc.stop(t0 + offset + 0.5);
    });
  } catch {
    /* autoplay blocked or no audio device */
  }
}
